import { Directive, ElementRef, HostListener, Renderer2, OnDestroy } from '@angular/core';

@Directive({
  selector: '[mdDragScroll]',
})
export class DragScrollDirective implements OnDestroy {
  private isDown = false;
  private startX = 0;
  private startY = 0;
  private scrollLeft = 0;
  private scrollTop = 0;
  private mouseMoveListener: () => void;
  private mouseUpListener: () => void;

  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.mouseMoveListener = this.renderer.listen(
      'window',
      'mousemove',
      this.onMouseMove.bind(this),
    );
    this.mouseUpListener = this.renderer.listen(
      'window',
      'mouseup',
      this.onMouseUp.bind(this),
    );
  }

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent) {
    this.isDown = true;
    this.el.nativeElement.classList.add('dragging');
    this.startX = event.pageX - this.el.nativeElement.offsetLeft;
    this.startY = event.pageY - this.el.nativeElement.offsetTop;
    this.scrollLeft = this.el.nativeElement.scrollLeft;
    this.scrollTop = this.el.nativeElement.scrollTop;
    event.preventDefault(); // Prevent text selection
  }

  onMouseMove(event: MouseEvent) {
    if (!this.isDown) {
      return;
    }
    event.preventDefault();
    const x = event.pageX - this.el.nativeElement.offsetLeft;
    const y = event.pageY - this.el.nativeElement.offsetTop;
    const walkX = x - this.startX;
    const walkY = y - this.startY;
    this.el.nativeElement.scrollLeft = this.scrollLeft - walkX;
    this.el.nativeElement.scrollTop = this.scrollTop - walkY;
  }

  onMouseUp() {
    this.isDown = false;
    this.el.nativeElement.classList.remove('dragging');
  }

  ngOnDestroy(): void {
    this.mouseMoveListener();
    this.mouseUpListener();
  }
}
